export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-aa53e633b8c10721876d.worker.js");
}
